import React from 'react'
import { useEffect } from 'react'
import {
  fetchPricing,
  selectCoupon,
  clearCoupon,
  setCouponButDoNotOverride,
} from '../store/pricingSlice'
import { useDispatch, useSelector } from 'react-redux'
import { getEntries } from 'js/contentful'
import useLocale from '../hooks/useLocale'

const PriceUpdater = ({ children }) => {
  const { currency } = useLocale()
  const selectedCoupon = useSelector(selectCoupon)
  const dispatch = useDispatch()

  const updatePrices = () => {
    const coupon = selectedCoupon

    // Fetch base pricing
    dispatch(fetchPricing())

    if (coupon) {
      dispatch(fetchPricing(coupon)).catch(() => {
        // Check if this coupon is still the selected one
        if (coupon === selectedCoupon) {
          dispatch(clearCoupon())
        }
      })
    }
  }

  useEffect(() => {
    if (navigator.userAgent.match('DisableForTesting')) return
    if (selectedCoupon) return
    let abort = false

    getEntries({
      content_type: 'blanketCampaign',
      limit: 1,
      order: 'sys.createdAt',
      'fields.startDate[lte]': new Date().toISOString(),
      'fields.endDate[gte]': new Date().toISOString(),
    }).then(entries => {
      if (abort) return
      if (entries.items.length === 0) return
      const coupon = entries.items[0].fields.couponCode
      dispatch(fetchPricing(coupon)).then(() => {
        dispatch(setCouponButDoNotOverride(coupon))
      })
    })

    return () => {
      abort = true
    }
  }, [selectedCoupon])

  useEffect(() => {
    updatePrices()
  }, [currency])

  return React.Children.only(children)
}

export default PriceUpdater
